(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mh-box-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  function makeFormatter(tplRaw) {
    var tpl = tplRaw || '';
    var m = tpl.match(/\d[\d.,]*\d|\d/);
    if (!m) {
      return function (cents) { return (cents / 100).toFixed(2); };
    }
    var num = m[0];
    var prefix = tpl.slice(0, m.index);
    var suffix = tpl.slice(m.index + num.length);
    var c3 = num.charAt(num.length - 3);
    var dec = '';
    var tho = ',';
    if (c3 === ',' || c3 === '.') {
      dec = c3;
      tho = c3 === ',' ? '.' : ',';
    }
    return function (cents) {
      var neg = cents < 0;
      var v = Math.abs(cents) / 100;
      var s = dec ? v.toFixed(2) : String(Math.round(v));
      var parts = s.split('.');
      var ip = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, tho);
      var body = ip;
      if (dec && parts.length > 1) body += dec + parts[1];
      return (neg ? '-' : '') + prefix + body + suffix;
    };
  }

  function unitPrice(v, qty) {
    var price = v.price;
    var best = null;
    var list = v.breaks || [];
    for (var i = 0; i < list.length; i++) {
      if (qty >= list[i].min) {
        if (best === null || list[i].min > best.min) best = list[i];
      }
    }
    if (best !== null) price = best.price;
    return price;
  }

  function tpl(str, map) {
    var out = str || '';
    for (var k in map) {
      if (Object.prototype.hasOwnProperty.call(map, k)) {
        out = out.split('[' + k + ']').join(map[k]);
      }
    }
    return out;
  }

  function init(root) {
    if (!root || root.getAttribute('data-mh-init') === '1') return;
    var cardEls = root.querySelectorAll('[data-mh-card]');
    if (!cardEls.length) return;
    root.setAttribute('data-mh-init', '1');

    var variants = {};
    for (var i = 0; i < cardEls.length; i++) {
      var el = cardEls[i];
      var id = el.getAttribute('data-variant-id');
      var base = parseInt(el.getAttribute('data-price'), 10) || 0;
      var raw = [];
      try {
        raw = JSON.parse(el.getAttribute('data-breaks') || '[]') || [];
      } catch (e) {
        raw = [];
      }
      var breaks = [];
      for (var j = 0; j < raw.length; j++) {
        var min = parseInt(raw[j][0], 10);
        var pr = parseInt(raw[j][1], 10);
        if (!min || !pr) continue;
        if (pr > base) continue;
        if (pr < base * 0.5) continue;
        breaks.push({ min: min, price: pr });
      }
      variants[String(id)] = {
        id: id,
        size: el.getAttribute('data-size'),
        name: el.getAttribute('data-name') || '',
        price: base,
        max: parseInt(el.getAttribute('data-max'), 10),
        breaks: breaks
      };
    }

    var STEP = parseInt(root.getAttribute('data-box-size'), 10) || 25;
    var CART_URL = root.getAttribute('data-cart-url') || '/cart';
    var fmt = makeFormatter(root.getAttribute('data-money-format'));

    var S = root.querySelector('.mhbox__strings');
    function str(name, fallback) {
      if (!S) return fallback;
      return S.getAttribute('data-s-' + name) || fallback;
    }

    var cards = Array.prototype.slice.call(cardEls);
    var modeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-mh-mode]'));
    var modeTag = root.querySelector('[data-mh-mode-tag]');
    var countEl = root.querySelector('[data-mh-count]');
    var goalEl = root.querySelector('[data-mh-goal]');
    var barEl = root.querySelector('[data-mh-bar]');
    var statusEl = root.querySelector('[data-mh-status]');
    var summaryEl = root.querySelector('[data-mh-summary]');
    var totalEl = root.querySelector('[data-mh-total]');
    var addBtn = root.querySelector('[data-mh-add]');
    var addLabel = root.querySelector('[data-mh-add-label]');
    var errEl = root.querySelector('[data-mh-error]');

    var qty = {};
    var mode = '100';
    var busy = false;
    var notice = '';

    function inScope(v) {
      if (!v) return false;
      if (mode === 'mix') return true;
      return v.size === mode;
    }

    function totalPieces() {
      var t = 0;
      for (var id in qty) {
        if (qty[id] > 0 && inScope(variants[id])) t += qty[id];
      }
      return t;
    }

    function showError(msg) {
      if (!errEl) return;
      if (msg) {
        errEl.textContent = msg;
        errEl.hidden = false;
      } else {
        errEl.textContent = '';
        errEl.hidden = true;
      }
    }

    function render() {
      var total = totalPieces();
      var boxes = Math.floor(total / STEP);
      var rest = total % STEP;
      var missing = rest === 0 ? 0 : STEP - rest;
      var valid = total > 0 && rest === 0;

      for (var c = 0; c < cards.length; c++) {
        var card = cards[c];
        var id = card.getAttribute('data-variant-id');
        var v = variants[id];
        var q = qty[id] || 0;
        card.hidden = !inScope(v);
        if (q > 0) card.classList.add('is-selected');
        else card.classList.remove('is-selected');
        var input = card.querySelector('[data-mh-qty]');
        if (input && String(q) !== input.value) input.value = String(q);
        var priceEl = card.querySelector('[data-mh-unit-price]');
        if (priceEl && v) priceEl.textContent = fmt(unitPrice(v, q));
      }

      if (modeTag) modeTag.textContent = str('mode-' + mode, '');
      if (countEl) countEl.textContent = String(total);
      if (goalEl) goalEl.textContent = String(boxes >= 1 ? (boxes + (rest > 0 ? 1 : 0)) * STEP : STEP);
      if (barEl) barEl.style.width = (rest === 0 && total > 0 ? 100 : (rest / STEP) * 100) + '%';

      var msg;
      if (total === 0) msg = str('empty', '');
      else if (valid) msg = tpl(str('ready', ''), { b: boxes });
      else if (boxes > 0) msg = tpl(str('boxes', ''), { b: boxes, n: missing });
      else msg = tpl(str('goal', ''), { n: missing });
      if (notice) msg = notice + ' ' + msg;
      if (statusEl) statusEl.textContent = msg;

      var lines = [];
      var money = 0;
      for (var id2 in qty) {
        var q2 = qty[id2];
        var v2 = variants[id2];
        if (!q2 || !inScope(v2)) continue;
        var up = unitPrice(v2, q2);
        money += up * q2;
        lines.push({ name: v2.name + ' ' + v2.size + ' ml', q: q2, sub: up * q2 });
      }
      lines.sort(function (a, b) { return a.name.localeCompare(b.name); });

      if (summaryEl) {
        summaryEl.innerHTML = '';
        for (var l = 0; l < lines.length; l++) {
          var li = document.createElement('li');
          var sa = document.createElement('span');
          sa.textContent = lines[l].q + ' \u00D7 ' + lines[l].name;
          var sb = document.createElement('span');
          sb.textContent = fmt(lines[l].sub);
          li.appendChild(sa);
          li.appendChild(sb);
          summaryEl.appendChild(li);
        }
      }

      if (totalEl) totalEl.textContent = total > 0 ? fmt(money) : '\u2014';
      if (addBtn) addBtn.disabled = !valid || busy;
    }

    function setMode(next) {
      if (next === mode) return;
      mode = next;
      var dropped = 0;
      for (var id in qty) {
        if (qty[id] > 0 && !inScope(variants[id])) {
          dropped += qty[id];
          qty[id] = 0;
        }
      }
      notice = dropped > 0 ? tpl(str('cleared', ''), { n: dropped }) : '';
      for (var m = 0; m < modeBtns.length; m++) {
        var on = modeBtns[m].getAttribute('data-mh-mode') === mode;
        modeBtns[m].classList.toggle('is-active', on);
        modeBtns[m].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      showError(null);
      render();
    }

    function setQty(id, next) {
      var v = variants[id];
      if (!v) return;
      var max = typeof v.max === 'number' && !isNaN(v.max) ? v.max : 99999;
      if (next < 0) next = 0;
      if (next > max) next = max;
      qty[id] = next;
      notice = '';
      showError(null);
      render();
    }

    root.addEventListener('click', function (e) {
      if (!e.target.closest) return;

      var modeBtn = e.target.closest('[data-mh-mode]');
      if (modeBtn) {
        setMode(modeBtn.getAttribute('data-mh-mode'));
        return;
      }

      var inc = e.target.closest('[data-mh-inc]');
      var dec = e.target.closest('[data-mh-dec]');
      if (inc || dec) {
        var card = (inc || dec).closest('[data-mh-card]');
        if (!card) return;
        var id = card.getAttribute('data-variant-id');
        setQty(id, (qty[id] || 0) + (inc ? 1 : -1));
        return;
      }

      if (e.target.closest('[data-mh-reset]')) {
        for (var k in qty) qty[k] = 0;
        notice = '';
        showError(null);
        render();
        return;
      }

      if (e.target.closest('[data-mh-add]')) submit();
    });

    root.addEventListener('change', function (e) {
      if (!e.target.closest) return;
      var input = e.target.closest('[data-mh-qty]');
      if (!input) return;
      var card = input.closest('[data-mh-card]');
      if (!card) return;
      var n = parseInt(input.value, 10);
      if (isNaN(n)) n = 0;
      setQty(card.getAttribute('data-variant-id'), n);
    });

    function submit() {
      if (busy) return;
      var total = totalPieces();
      if (total === 0 || total % STEP !== 0) return;

      var items = [];
      for (var id in qty) {
        var v = variants[id];
        if (!qty[id] || !inScope(v)) continue;
        items.push({
          id: parseInt(id, 10),
          quantity: qty[id],
          properties: { _mh_box: mode }
        });
      }
      if (!items.length) return;

      busy = true;
      showError(null);
      if (addLabel) addLabel.textContent = str('adding', '...');
      render();

      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(routeRoot.replace(/\/$/, '') + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (json) {
            return { ok: r.ok, json: json };
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error((res.json && res.json.description) || 'error');
          window.location.assign(CART_URL);
        })
        .catch(function (err) {
          busy = false;
          if (addLabel) addLabel.textContent = str('add', 'Add');
          showError((err && err.message) || str('error', 'Error'));
          render();
        });
    }

    render();
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-mh-box-builder]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
